// extracted by mini-css-extract-plugin
module.exports = {"story-wrapper":"_2-8Mt"};